import './Slider.css';
import React, { useRef, useEffect } from 'react';
import ReactSlider from '@mui/material/Slider';


function Slider(props) {
    const sliderRef = useRef(null);

    useEffect(() => {
      if (sliderRef.current) {
        const inputElement = sliderRef.current.querySelector('input');
        if (inputElement) {
          inputElement.setAttribute('data-copy-bot', props.name);
        }
      }
    }, [props.name]);

    return (
        <ReactSlider
            ref={sliderRef}
            defaultValue={0}
            value={props.value}
            min={0}
            max={10}
            marks={marks}
            valueLabelDisplay="auto"
            onChange={(_, newValue) => props.onChange(newValue)}
            name={props.name}
        />
    )
}


export default Slider;

const marks = [
    { value: 0, label: '0' },
    { value: 10, label: '10' },
]